define("checkout/components/seamless-checkout", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{! NOTE: there should only be one of these inserted into the app }}
  {{#if this.showTrialPlansModal}}
    <SeamlessCheckout::TrialPlansModal />
  {{else if this.showCheckoutModal}}
    <SeamlessCheckout::CheckoutModal />
  {{else if this.showCheckoutSuccessModal}}
    <SeamlessCheckout::CheckoutSuccessModal />
  {{else if this.showNonAdminModal}}
    <SeamlessCheckout::NonAdminModal />
  {{/if}}
  {{! Future: feature highlight modal }}
  */
  {
    "id": "/Fj3khde",
    "block": "[[[41,[30,0,[\"showTrialPlansModal\"]],[[[1,\"  \"],[8,[39,1],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showCheckoutModal\"]],[[[1,\"  \"],[8,[39,2],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showCheckoutSuccessModal\"]],[[[1,\"  \"],[8,[39,3],null,null,null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showNonAdminModal\"]],[[[1,\"  \"],[8,[39,4],null,null,null],[1,\"\\n\"]],[]],null]],[]]]],[]]]],[]]]],[],false,[\"if\",\"seamless-checkout/trial-plans-modal\",\"seamless-checkout/checkout-modal\",\"seamless-checkout/checkout-success-modal\",\"seamless-checkout/non-admin-modal\"]]",
    "moduleName": "checkout/components/seamless-checkout.hbs",
    "isStrictMode": false
  });
  let SeamlessCheckoutComponent = _exports.default = (_class = class SeamlessCheckoutComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor, this);
    }
    get showNonAdminModal() {
      return this.seamlessCheckoutManager.showNonAdminModal;
    }
    get showCheckoutModal() {
      return this.seamlessCheckoutManager.showCheckoutModal;
    }
    get showTrialPlansModal() {
      return this.seamlessCheckoutManager.showTrialPlansModal;
    }
    get showCheckoutSuccessModal() {
      return this.seamlessCheckoutManager.showCheckoutSuccessModal;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SeamlessCheckoutComponent);
});